import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from 'primereact/checkbox'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown'
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { AuthContext } from '../../main/ProvedorAutenticacao'

import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import GrupoTrabalhoService from "../../app/service/GrupoTrabalhoService";
import AtividadeService from "../../app/service/AtividadeService";
import ProcessoService from "../../app/service/ProcessoService";
import GrupoAtividadeService from "../../app/service/GrupoAtividadeService";
import RodizioUsuarioService from "../../app/service/RodizioUsuarioService";

class RodizioAtividadeComponent extends Component {
	constructor(props) {
			super(props);

			this.state = {
				openSpinner: false,
				codigoProcesso: '',
				modalAtividadeInclusao: false,
				descricao: '',
				processo: null,
				processos: [],
				//Atividade
				pesquisaProcesso: '',
				processoPesquisado: '',
				partes: [],
				gruposTrabalho: [],
				grupoTrabalho: null,
				subGrupos: [],
				subGrupoId: '',
				subGrupo: null,
				//Tudo de Rodízio vem aqui para baixo
				gruposAtividade: [],
				grupoAtividade: null,
				atividadesRodizio: [], // Exibe as atividades do grupo de ativiodade selecionado
			}

			this.tituloService = new TituloAtividadeService();
			this.grupoTrabalhoService = new GrupoTrabalhoService();
			this.atividadeService = new AtividadeService();
			this.processoService = new ProcessoService();
			this.grupoAtividadeService = new GrupoAtividadeService();
			this.rodizioUsuarioService = new RodizioUsuarioService();

			this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
			this.onGrauChange = this.onGrauChange.bind(this);
			this.acoesProcesso = this.acoesProcesso.bind(this);
			this.onChangeGrupoAtividade = this.onChangeGrupoAtividade.bind(this);
			this.onChangeGrupoTrabalho = this.onChangeGrupoTrabalho.bind(this);
	}


	//Rodízio
	listarGruposAtividade = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		return await this.grupoAtividadeService.listar(usuarioLogado.empresa.codigo)
			.then(response => {
				this.setState({gruposAtividade: response.data});
				return response.data;
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', 
					               summary: 'Grupos de Atividade - Criação de Atividades', 
												 detail:`${this.state.detail}`, life: 4000});
				return [];
			})
	}

	listarGruposAtividadePorProcesso = async (processoId) => {
		return await this.grupoAtividadeService.listarGruposAtividadePorProcesso(processoId)
			.then(response => {
				this.setState({gruposAtividade: response.data});
				return response.data;
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', 
					               summary: 'Grupos de Atividade - Criação de Atividades', 
												 detail:`${this.state.detail}`, life: 4000});
				return [];
			})
	}

	async onChangeGrupoAtividade(e) {
		if(e.value == null) {
			this.setState({grupoAtividade: null, atividadesRodizio: []});
			return;
		}

		const grupoTrabalho = this.state.grupoTrabalho;
		const processoSelecionado = this.state.processo;

		this.setState({openSpinner: true, 
			             grupoAtividade: e.value,
								 	 atividadesRodizio: [],
									 grupoTrabalho: processoSelecionado != null ? grupoTrabalho : null});

		await this.listarGruposTrabalho(e.value);

		if(processoSelecionado != null && grupoTrabalho != null) {
			await this.exibirAtividadesRodizio(grupoTrabalho.codigo,e.value.codigo);
		}

		this.setState({openSpinner: false});
	}

	consultarSubGrupoTrabalho = async (subGrupoId) => {
		await this.grupoTrabalhoService.consultarGrupo(subGrupoId)
			.then(response => {
				this.setState({subGrupo: response.data});		
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', 
					               summary: 'Sub-Grupos de Atividade - Consulta', 
												 detail:`${this.state.detail}`, life: 4000});
			})
	}

	exibirAtividadesRodizio = async (grupoTrabalho, grupoAtividade) => {
		await this.rodizioUsuarioService.buscarRodizio(grupoTrabalho,grupoAtividade)
			.then(response => {
				this.setState({atividadesRodizio: response.data});
				if(response.data != null && response.data.length > 0) {
					this.setState({
						subGrupoId: response.data[0].subGrupoTrabalho,
						subGrupo: {
							codigo: response.data[0].subGrupoTrabalho
							}
						});
				} else {
					this.setState({
						subGrupoId: '',
						subGrupo: null
					});
				}
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', 
					               summary: 'Rodízio de Usuários - Exibição das Atividades', 
												 detail:`${this.state.detail}`, life: 4000});
			})
	}

	async onChangeGrupoTrabalho(e) {
		if(e.value == null) {
			this.setState({grupoTrabalho: null,atividadesRodizio: []});
			return;
		}
		this.setState({openSpinner: true, grupoTrabalho: e.value});
		await this.exibirAtividadesRodizio(e.value.codigo,this.state.grupoAtividade.codigo);
		//await this.consultarSubGrupoTrabalho(this.state.subGrupoId);
		//await this.consultarSubGrupos(e.value);
		this.setState({openSpinner: false});
	}

	//Cadastrar Atividade
	converterDataParaISO(data) {
		if (!data) return null;
		const [dia, mes, ano] = data.split('/');
		return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
	}

	cadastrarAtividade = async () => {
		if(this.state.atividadesRodizio == null || this.state.atividadesRodizio.length === 0) {
			 this.toast.show({severity:'error', 
					              summary: 'Rodízio de Atividades - Criação de Atividades', 
												detail:'Nenhum atividade encontrada', 
												life: 5000});
				return;
		}

		if(this.state.grupoTrabalho == null) {
			this.toast.show({severity:'error', 
					              summary: 'Rodízio de Atividades - Criação de Atividades', 
												detail:'Informe o Grupo de Trabalho', 
												life: 5000});
				return;
		}

		var processo = null;
    if(this.state.processo != null) {
      processo = {
        codigo: this.state.processo.codigo
      }
    }

		var atividades = [];
		var responsaveis = [];

		const usuarioLogado = this.context.usuarioAutenticado;
		for(let i = 0; i < this.state.atividadesRodizio.length; i++) {
			const atividadeRodizio = this.state.atividadesRodizio[i];
			const subGrupo = atividadeRodizio.subGrupoTrabalho != null
				? {
					codigo: atividadeRodizio.subGrupoTrabalho,
					nome: atividadeRodizio.subGrupoTrabalhoNome,
					grupoPai: this.state.processo.grupoTrabalho.codigo
				}
				: null;
			
			responsaveis = [];
			const responsavel = {
				codigo: atividadeRodizio.usuarioId,
				nome: atividadeRodizio.nousuario
			}
			responsaveis.push(responsavel);

			const request = {
				atividade: {
					titulo: atividadeRodizio.dstitulo,
					processo: processo,
					subGrupo: subGrupo,
					dtLimite: this.converterDataParaISO(atividadeRodizio.dataLimite),
					dtFatal: atividadeRodizio.prazoFatal === 0 
										? null 
										: this.converterDataParaISO(atividadeRodizio.dataPrazoFatal),
					descricao: this.state.descricao,
					usuario: usuarioLogado,
					tipo: 'T',
					status: {
						codigo: 1
					}, // Ativo
					importante: atividadeRodizio.importante == 'SIM' ? 'S' : 'N',
					urgente: atividadeRodizio.urgente == 'SIM' ? 'S' : 'N',
					privado: atividadeRodizio.privado == 'SIM' ? 'S' : 'N',
					pessoa: null,
					tituloAtividade: {
						codigo: atividadeRodizio.codigoTitulo
					},
					lancamentoFinanceiro: null
				},
				responsaveis: responsaveis,
				interessados: null,
				arquivos: null,
				recorrencia: '0',
				responsaveisSubTarefas: null,
				interessadosSubTarefas: null,
				empresaId: usuarioLogado.empresa.codigo
			}
			atividades.push(request);
		}
		const request = {
			grupoAtividade: this.state.grupoAtividade,
			grupoTrabalho: this.state.grupoTrabalho,
			usuario: usuarioLogado,
			atividades: atividades
		}

		this.setState({openSpinner: true});
		await this.atividadeService.cadastrarAtividadeRodizio(request)
			.then(async response => {
				this.setState({openSpinner: false});
				this.toast.show({severity:'success', 
												summary: 'Rodízio de Atividades - Criação de Atividades', 
												detail:'Atividades cadastradas com sucesso', 
												life: 5000});
				if(this.props.onCadastroConcluido != null) {
					await this.props.onCadastroConcluido();
				}
				this.fecharModal();
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
				this.toast.show({severity:'error', 
					               summary: 'Rodízio de Atividades - Criação de Atividades', 
												 detail:`${this.state.detail}`, life: 4000});
			})

	}
	//Fim de Rodízio


	consultarProcessoPorIndice = async() => {
		if(this.state.grupoAtividade == null) {
			 this.toast.show({severity:'success', 
					              summary: 'Rodízio de Atividades - Criação de Atividades', 
												detail:'Informe o grupo de atividade para limitar as buscas de processo ou grupo de trabalho', 
												life: 4000});
			 return;
		}
    const usuarioLogado = this.context.usuarioAutenticado;
    const indice = {
      indice: this.state.pesquisaProcesso,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
			grupoAtividade: this.state.grupoAtividade.codigo
    }
		this.setState({openSpinner: true});
    await this.processoService.consultarProcessoParaRodizio(indice)
      .then(response => {
        this.setState({processos: response.data});
        if(response.data.length > 0) {
          this.setState({modalProcessos: true});
        } else {
          this.setState({pesquisaProcesso: ''});
          this.toast.show({severity:'error', summary: 'Processos', detail:'Processo não encontrado', life: 4000});
        }
				this.setState({openSpinner: false});
      }).catch(error => {
				this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Consulta de Processos', detail:`${this.state.detail}`, life: 4000});
      });
  }

	listarGruposTrabalho = async (grupoAtividade) => {
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.grupoTrabalhoService.consultarParaRodizio(grupoAtividade.codigo)
			.then(response => {
				this.setState({gruposTrabalho: response.data});
			}).catch(error => {
			  this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Grupos de Trabalho - Listagem', 
					               detail:`${this.state.detail}`, 
												 life: 4000});
			})
	}

	acoesProcesso(rowData) {
		return(
			<React.Fragment>
				<Button icon="pi pi-check" className="p-button-rounded p-button-text" 
								tooltip="Selecionar"
								onClick={() => this.selecionarProcesso(rowData)}
								tooltipOptions={{position: 'top'}} />
			</React.Fragment>
		);
	}

	async selecionarProcesso(processo) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.processoService.consultarProcessoPorCodigo(processo.codigo, usuarioLogado.codigo)
      .then(response => {
	      this.setState({processo: response.data});
				this.setState({partes: response.data.partes})
        this.setState({pesquisaProcesso: processo.nrCnj});
        this.setState({grupoTrabalho: response.data.grupoTrabalho});
        if(response.data.nrCnj != '' && response.data.nrCnj != null) {
          var cnjMascarado = response.data.nrCnj.substring(0, 7);
              cnjMascarado = cnjMascarado + "-" + response.data.nrCnj.substring(7, 9);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(9, 13);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(13, 14);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(14, 16);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(16, 20);
            	this.setState({processoPesquisado: cnjMascarado});
        } else {
          this.setState({processoPesquisado: response.data.nrProcesso});
        }
				this.exibirAtividadesRodizio(response.data.grupoTrabalho.codigo,this.state.grupoAtividade.codigo);
        this.consultarSubGrupos(response.data.grupoTrabalho);
				this.setState({openSpinner: false, modalProcessos: false});
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Pesquisa de Processos', detail:`${this.state.detail}`, life: 4000});
      });
  }

	consultarSubGrupos = async(grupo) => {
    await this.grupoTrabalhoService.listarSubGrupos(grupo.codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', 
					               detail:'Erro ao carregar Sub-Grupos de Trabalho', 
												 life: 4000});
      })
  }

	listarTitulosAtividade = async (empresa) => {
		this.tituloService.listar(empresa)
		.then(response => {
				this.setState({titulos: response.data});
		}).catch(error => {
				this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
		})
	}


	onGrauChange(e) {
		let selectedGrau = [...this.state.grau];

		if (e.checked)
		selectedGrau.push(e.value);
		else
		selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

		this.setState({ grau: selectedGrau });
	}

	pad2 = (n) => {
		return (n < 10 ? '0' : '') + n;
	}

	fecharModal() {
		this.props.onHide();
	}

	formatarProcessoPesquisado(processo) {
		if(processo == null) {
			return '';
		}

		if(processo.nrCnj != '' && processo.nrCnj != null) {
			var cnjMascarado = processo.nrCnj.substring(0, 7);
					cnjMascarado = cnjMascarado + "-" + processo.nrCnj.substring(7, 9);
					cnjMascarado = cnjMascarado + "." + processo.nrCnj.substring(9, 13);
					cnjMascarado = cnjMascarado + "." + processo.nrCnj.substring(13, 14);
					cnjMascarado = cnjMascarado + "." + processo.nrCnj.substring(14, 16);
					cnjMascarado = cnjMascarado + "." + processo.nrCnj.substring(16, 20);
			return cnjMascarado;
		}

		return processo.nrProcesso;
	}

	carregarProcessoSelecionado = async (processo) => {
		if(processo == null || processo.codigo == null) {
			await this.listarGruposAtividade();
			return;
		}

		const grupoTrabalho = processo.grupoTrabalho != null
			? processo.grupoTrabalho
			: null;

		this.setState({
			processo: processo,
			partes: processo.partes || [],
			pesquisaProcesso: processo.nrCnj || processo.nrProcesso || '',
			processoPesquisado: this.formatarProcessoPesquisado(processo),
			grupoTrabalho: grupoTrabalho
		});

		const gruposAtividade = await this.listarGruposAtividadePorProcesso(processo.codigo);

		if(gruposAtividade != null && gruposAtividade.length > 0) {
			const grupoAtividade = gruposAtividade[0];
			this.setState({grupoAtividade: grupoAtividade});
			await this.listarGruposTrabalho(grupoAtividade);

			if(grupoTrabalho != null) {
				await this.exibirAtividadesRodizio(grupoTrabalho.codigo, grupoAtividade.codigo);
			}
		}
	}

	fecharModalProcessos = () => {
  	this.setState({ modalProcessos: false });
	}

	renderFooterAtividade(name) {
		return (
			<div className="left">
					<Button label="Cadastrar" 
									className="p-button-primary p-button-text"
									onClick={this.cadastrarAtividade}/>
					&nbsp;
					<Button label="Anexar" 
									icon="pi pi-paperclip"
									onClick={() => this.abrirModalAnexo('displayAnexoNovaAtividade')}
									className="p-button-help p-button-text"/>
					&nbsp;
					<Button
						label="Cancelar"
						className="p-button-secondary p-button-text"
						onClick={this.props.onHide}
						/>
			</div>
		);
	}

	novaAtividade = async () => {
		this.setState({openSpinner: true,
									 grupoAtividade: null,
			             grupoTrabalho: null,
									 subGrupo: null,
									 gruposTrabalho: [],
									 subGrupos: [],
									 atividadesRodizio: [],
									 processos: [],
									 processo: null,
									 processoPesquisado: '',
									 pesquisaProcesso: '',
									 descricao: '',
									 partes: []
									 
		});
		await this.carregarProcessoSelecionado(this.props.processoSelecionado);
		this.setState({openSpinner: false});
	}

	abrirModal(name, position) {
		let state = {
				[`${name}`]: true
		};

		if (position) {
				state = {
						...state,
						position
				}
		}
		this.setState(state);
	}

	async componentDidUpdate(prevProps) {
		if (
			this.props.visible &&
			this.props.visible !== prevProps.visible
		) {
			await this.novaAtividade();
		}
	}

	render() {
		const { visible, onHide } = this.props;
		return(
				<>
					<Toast ref={(el) => this.toast = el} />
					<Dialog header="Incluir Atividade"
									visible={visible}
									style={{ width: '43vw' }}
									footer={this.renderFooterAtividade('modalAtividadeInclusao')} 
									onHide={onHide}>
							<div style={{ position: 'relative' }}>
							{/* 🔥 SPINNER AQUI */}
							{this.state.openSpinner && (
								<div style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									backgroundColor: 'rgba(0,0,0,0.5)',
									zIndex: 9999,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center'
								}}>
									<CircularProgress style={{ width: '130px', height: '130px', color: '#fff' }} />
								</div>
							)}
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<Dropdown value={this.state.grupoAtividade}
															options={this.state.gruposAtividade} 
															style={{width: '100%', height: '32px'}}
															optionLabel="nome" 
															filter showClear filterBy="nome"
															onChange={this.onChangeGrupoAtividade}
															id="idGrupoAtividade"
															emptyMessage=" "
															className="p-inputtext-sm p-d-block p-mb-1"
															placeholder="Grupo de Atividade"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										{!this.state.processo ? (
												<InputText
													id="idPesquisaProcesso"
													style={{width: '100%', height: '32px'}}
													value={this.state.pesquisaProcesso}
													onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
													onChange={e => this.setState({pesquisaProcesso: e.target.value})}
													className="p-inputtext-sm p-d-block p-mb-1"
													placeholder="Incluir Processo, Pesquise o processo por Pessoa, Pasta ou Número"
												/>
											) : (
												<div style={{ marginBottom: '10px' }}>
													
													{/* Número + link */}
													<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
														
														<span style={{ color: '#1976d2', fontWeight: 'bold', fontSize: '14px' }}>
															{this.state.processoPesquisado}
														</span>

														<span
															style={{ color: '#1976d2', cursor: 'pointer', fontSize: '12px' }}
															onClick={() => this.setState({
																processo: null,
																partes: [],
																pesquisaProcesso: '',
																processoPesquisado: ''
															})}
														>
															Nova pesquisa
														</span>
													</div>

												</div>
											)}
											{this.state.processo && (
												<div style={{ marginTop: '10px' }}>
													
													<div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '13px' }}>
														Partes do processo
													</div>

													<div style={{
														border: '1px solid #ddd',
														borderRadius: '6px',
														overflow: 'hidden'
													}}>
														
														<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
															<tbody>
																{this.state.partes && this.state.partes.length > 0 ? (
																	this.state.partes.map((parte, index) => (
																		<tr key={index} style={{
																			backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff'
																		}}>
																			<td style={{ padding: '8px' }}>
																				{parte.pessoa.nome}
																			</td>
																		</tr>
																	))
																) : (
																	<tr>
																		<td style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
																			Nenhuma parte encontrada
																		</td>
																	</tr>
																)}
															</tbody>
														</table>

													</div>
												</div>
											)}
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<Dropdown
												value={this.state.grupoTrabalho}
												options={this.state.gruposTrabalho}
												style={{width: '100%', height: '32px'}}
												optionLabel="nome"
												filter
												showClear
												filterBy="nome"
												emptyMessage=" "
												onChange={this.onChangeGrupoTrabalho}
												disabled={!!this.state.processo}
												placeholder="Grupo de Trabaho"
											/>
									</div>
								</div>
							</div>
							{this.state.atividadesRodizio && this.state.atividadesRodizio.length > 0 && (
								<div className="row" style={{ marginTop: '15px' }}>
									<div className="col-sm-12">
										
										<div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
											Atividades do Rodízio
										</div>

										<div style={{
											border: '1px solid #ddd',
											borderRadius: '6px',
											overflow: 'hidden'
										}}>
											
											<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
												
												<thead style={{ backgroundColor: '#f5f5f5' }}>
													<tr>
														<th style={{ padding: '8px', textAlign: 'left' }}>Atividade</th>
														<th style={{ padding: '8px', textAlign: 'left' }}>Prazo</th>
														<th style={{ padding: '8px', textAlign: 'left' }}>Prazo Fatal</th>
														<th style={{ padding: '8px', textAlign: 'left' }}>Importante</th>
														<th style={{ padding: '8px', textAlign: 'left' }}>Urgente</th>
														<th style={{ padding: '8px', textAlign: 'left' }}>Privado</th>
														<th style={{ padding: '8px', textAlign: 'left' }}>Usuário</th>
														<th style={{ padding: '8px', textAlign: 'left' }}>Sub-Grupo</th>
													</tr>
												</thead>

												<tbody>
													{this.state.atividadesRodizio.map((atividade, index) => (
														<tr key={index} style={{
															backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff'
														}}>
															<td style={{ padding: '8px' }}>
																{atividade.nome || atividade.dstitulo}
															</td>
															<td style={{ padding: '8px' }}>
																({atividade.prazo}&nbsp;dias)&nbsp;
																{atividade.dataLimite}
															</td>
															<td style={{ padding: '8px' }}>
																{atividade.prazoFatal !== 0 && (
																	<>
																		({atividade.prazoFatal}&nbsp;dias)&nbsp;
																		{atividade.dataPrazoFatal}
																	</>
																)}
															</td>
															<td style={{ padding: '8px' }}>
																{atividade.importante}
															</td>
															<td style={{ padding: '8px' }}>
																{atividade.urgente}
															</td>
															<td style={{ padding: '8px' }}>
																{atividade.privado}
															</td>
															<td style={{ padding: '8px' }}>
																{atividade.nousuario}
															</td>
															<td style={{ padding: '8px' }}>
																{atividade.subGrupoTrabalhoNome}
															</td>
														</tr>
													))}
												</tbody>

											</table>

										</div>

									</div>
								</div>
							)}
							<br></br>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<InputTextarea id="descricao" 
																	type="text" 
																	autoComplete="nope"
																	style={{width: '100%'}} 
																	value={this.state.descricao}
																	onChange={e => this.setState({descricao: e.target.value})}
																	className="p-inputtext-sm p-d-block p-mb-1"
																	rows={3} cols={30}
																	placeholder="Descrição da Atividade"/>
									</div>
								</div>
							</div>			
						</div>
					</Dialog>
					{/**Pesquisa de Processos */}
					<Dialog header="Busca de Processo"
									visible={this.state.modalProcessos} 
									style={{ width: '60vw' }} 
									footer={
										<div>
											<Button label="Fechar" 
															className="p-button-primary p-button-text"
															onClick={this.fecharModalProcessos}/>
										</div>
									} 
									onHide={() => this.fecharModal('modalProcessos')}> 
							<DataTable value={this.state.processos}  alwaysShowPaginator responsiveLayout="scroll"
												paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
												currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
												paginatorRight selectionMode="multiple">
								<Column field="pasta" header="Pasta"></Column>
								<Column field="nrProcesso" header="Processo Original"></Column>
								<Column field="nrCnj" header="Numeração Única"></Column>
								<Column field="autor" header="Autor x Réu" style={{width: '300px'}}></Column>
								<Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
								<Column body={this.acoesProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
							</DataTable>
					</Dialog>
				</>
		);
	}
}
RodizioAtividadeComponent.contextType = AuthContext;
export default RodizioAtividadeComponent;
